export default {
  methods: {
    get_base_url() {
      /*if( process.env.NODE_ENV === 'development')
      {
        return ''
      }
      */
      return 'https://kundenverwaltung.np-gruppe.de:46346'
    },
    /*
    zeigeNotification(title, body) {
      if (!('Notification' in window)) {
        return
      }

      const options = { 'body': body }
      if (Notification.permission === 'granted') 
      {
        navigator.serviceWorker.getRegistrations().then(function(registrations) {
          registrations[0].showNotification(title, options)
        })
        return
      }

      if (Notification.permission !== 'denied') 
      {
        return Notification.requestPermission(function (permission) 
          {
            if (permission === 'granted') 
            {
              navigator.serviceWorker.getRegistrations().then(function(registrations) {
                registrations[0].showNotification(title, options)
              })
            }
        })
      }
    },
    */
    get_hauptbild_url_fuer_vertrag(vertrag)
    {
      var url = false
      if( !vertrag)
      {
        return url
      }
      for( const wohnung of vertrag.wohnungen)
      {
        if( wohnung.immobilie)
        {
          for( const bild of wohnung.immobilie.bilder)
          {
            if( bild && bild.mime_type === 'image/jpeg' && bild.url && bild.url !== '' && bild.url !== 'false')
            {
              return this.get_base_url() + bild.url
            }
          }
        }
        if( wohnung.bilder)
        {
          for( const bild of wohnung.bilder)
          {
            if( bild && bild.mime_type === 'image/jpeg' && bild.url && bild.url !== '' && bild.url !== 'false')
            {
              return this.get_base_url() + bild.url
            }
          }
        }
      }
      /*if( process.env.NODE_ENV === 'development')
      {
        return url
      }
      */
      if( !url || url === '' || url === 'false')
      {
        return false
      }
      return 'https://kundenverwaltung.np-gruppe.de:46346/' + url
    },
    format_euro(number)
    {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(Number.parseFloat(number))
    },
    parseTime(t)
    {
      if( !t || t === '')
      {
        return ''
      }
      return t.match(/\d\d:\d\d/)[0]
    },
    capitalizeFirstLetter( str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    },
    getBeginningOfWeek( d, store) {
      if( !d) 
      {
        d = new Date()
      }
      const day = d.getUTCDay()
      const erster_wochentag = this.getErsterWochentagReihenfolge(store)

      let diff = d.getUTCDate() - day + (day === 0 ? -6 : 1) // adjust when day is sunday
      if( erster_wochentag === 0 && d.getUTCDay() === 0) // woche beginnt mit sonntag und datum ist sonntag
      {
        diff = d.getUTCDate() - day 
      }

      let ret = new Date(d.setDate(diff))
      return ret
    },
    getEndOfWeek ( d, store) {
      if( !d) 
      {
        d = new Date()
      }
      return this.addDaysToDate(this.getBeginningOfWeek(d, store), 6)
    },
    formatDateForREST (date) {
      if (!date) {
        return false
      }
      return date.getUTCFullYear() + '-' + (date.getUTCMonth() + 1).toString().padStart(2, '0') + '-' + date.getUTCDate().toString().padStart(2, '0')
    },
    formatDateTimeForREST (date) {
      if (!date) {
        return false
      }
      return date.getUTCFullYear() + '-' + (date.getUTCMonth() + 1).toString().padStart(2, '0') + '-' + date.getUTCDate().toString().padStart(2, '0') + ' ' + date.getHours().toString().padStart(2, '0') + ':' + date.getMinutes().toString().padStart(2, '0') + 'Z'
    },
    formatDateForHTML (date) {
      if (!date) {
        date = new Date()
      }
      if( typeof date === 'string')
      {
        date = new Date(Date.parse(date))
      }
      return date.getUTCDate().toString().padStart(2, '0') + '.' + (date.getUTCMonth() + 1).toString().padStart(2, '0') + '.' + date.getUTCFullYear()
    },
    formatTimeForHTML (date) {
      return date.getUTCHours().toString().padStart(2, '0') + ':' + (date.getMinutes()).toString().padStart(2, '0')
    },
    addDaysToDate (date, days) {
      let result = new Date(date)
      result.setDate(result.getUTCDate() + days)
      return result
    },
    truncateString (string, maxlen, append = '..') {
      if (!string) {
        return ''
      }
      if (string.length <= maxlen) {
        return string
      }
      return string.substring(0, maxlen - (append.length)) + append
    },
    getDateWithoutTime( date)
    {
      var d = new Date(date)
      d.setUTCHours(0, 0, 0, 0)
      return d
    },
    truncateTimeFromRestDateTimeString( str)
    {
      return str.substr( 0, 10)
    }
  }
}
